import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { ObjectProps, Sphere, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 3,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { type: 'Box', position: [ 0, 0, 0], args: [4, 0.15, 1] },
    ], 
    type: 'Dynamic'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Sphere position={[ 1.65, 0,   0]} args={[0.5]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
      <Sphere position={[-1.65, 0,   0]} args={[0.5]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
      <Sphere position={[-1.1, 0, -0.2]} args={[0.4]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
      <Sphere position={[-1.0, 0,  0.2]} args={[0.4]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
      <Sphere position={[-0.6, 0, -0.3]} args={[0.4]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
      <Sphere position={[-0.5, 0,  0.2]} args={[0.5]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
      <Sphere position={[ 0.0, 0, -0.2]} args={[0.3]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
      <Sphere position={[ 0.1, 0,  0.3]} args={[0.4]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
      <Sphere position={[ 0.5, 0, -0.2]} args={[0.4]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
      <Sphere position={[ 0.6, 0,  0.3]} args={[0.3]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
      <Sphere position={[ 1.0, 0,-0.15]} args={[0.3]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
      <Sphere position={[ 1.1, 0,  0.3]} args={[0.4]} scale={[1, 0.2, 1]} isMeshStandardMaterial={false} />
    </group>
  );
};
